import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';

export enum Company {
  COMESA = 'comesa',
  RAWSUR = 'rawsur',
  MUBARAK = 'mubarak',
}
export const companies: Record<Company, Record<'name' | 'key' | 'short' | 'description', string>> = {
  comesa: {
    name: 'YC Comesa',
    description: 'COMESA Yellow Card · Cross-border',
    key: 'comesa',
    short: 'YC'
  },
  rawsur: {
    name: 'Rawsur',
    description: 'DRC Political Violence · PVT',
    key: 'rawsur',
    short: 'rs'
  },
  mubarak: {
    name: 'Mubarak Drizit',
    description: 'UAE & Gulf Region · Multi-line',
    key: 'mubarak',
    short: 'MD'
  }
}

@Component({
  selector: 'app-company-logo',
  imports: [],
  templateUrl: './company-logo.html',
  styleUrl: './company-logo.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyLogo {
  public readonly companyName = input.required<Company>();
  public readonly companyData = computed(() => companies[this.companyName()])
}
